
export function getLocalStorageValue(key, defaultValue) {
    const item = localStorage.getItem(key);
    const initial = JSON.parse(item);
    return initial || defaultValue;
}

export function setLocalStorageValue(key, value) {
    const item = JSON.stringify(value)
    localStorage.setItem(key, item)
}